import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CurrencyPipe } from '@angular/common'
import { ChartsModule } from 'ng2-charts';
import { AgGridModule } from 'ag-grid-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { LoaderService } from './services/loader.service';
import { MaterialModule } from './routing/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GenericHttpClient } from './Services/Basicauthentication';
import { NgApexchartsModule } from "ng-apexcharts";
import { TableFilterPipe } from './resources/table-filter.pipe';
import { GoogleChartsModule } from 'angular-google-charts';
import{NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown'



import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GlobalDashboardComponent } from './global-dashboard/global-dashboard.component';
import { AdminmenuComponent } from './adminmenu/adminmenu.component';
import { LoginComponent } from './login/login.component';
import { UserMaintenanceComponent } from './user-maintenance/user-maintenance.component';
import { AddUpdateuserComponent } from './add-updateuser/add-updateuser.component';
import { UtilityServices } from './UtilityServices';
import { CommonModule } from '@angular/common';
import { ProjectlistComponent } from './projectlist/projectlist.component';
import { PiechartgridComponent } from './piechartgrid/piechartgrid.component';
import { MatSortModule } from '@angular/material/sort';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { ResourcesComponent } from './resources/resources.component';


@NgModule({
   declarations: [
      AppComponent,
      GlobalDashboardComponent,
      AddUpdateuserComponent,
      AdminmenuComponent,
      LoginComponent,
      UserMaintenanceComponent,
      ProjectlistComponent,
      PiechartgridComponent,
      LandingpageComponent,
      ResourcesComponent,
      TableFilterPipe
   ],
   imports: [
      BrowserModule,
      ChartsModule,
      HttpClientModule,
      CommonModule,
      AppRoutingModule,
      AgGridModule.withComponents([]),
      NgSelectModule,
      FormsModule,
      ReactiveFormsModule,
      MaterialModule,
      BrowserAnimationsModule,
      NgApexchartsModule,
      MatSortModule,
      GoogleChartsModule,
      NgMultiSelectDropDownModule.forRoot()
   ],
   providers: [LoaderService, GenericHttpClient, UtilityServices, CurrencyPipe],
   schemas: [
      CUSTOM_ELEMENTS_SCHEMA
   ],
   entryComponents: [],
   bootstrap: [
      AppComponent
   ]
})
export class AppModule { }
